import './footersty.css';
import React from 'react'
import { FaHome, FaPhone, FaMailBulk, FaGithub, FaInstagram, FaSpotify, FaLinkedin  } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styled, {keyframes} from 'styled-components';


const footer = () => {
  return (
    <div className='footer'>
        <div className='footer-container'>
            <div className='left'>
                <div className='location'>
                    <FaHome size={20} style={
                      {color:"#fff", marginRight:"2rem"}
                    }/>
                    <div>
                      <p>11806-00400,</p>
                      <p>Nairobi,Kenya.</p>
                    </div>
                  </div>
                  
                    <div className='phone'>
                    <h4><FaPhone size={18} 
                    style={
                      {color:"#fff", marginRight:"2rem"}
                    } />
                      +254712592154</h4>
            </div>
            <div className='email'>
                    <h4><FaMailBulk size={20} style={
                      {color:"#fff", marginRight:"2rem"}
                    } />
                      shitsamajohn821@gmail.com</h4>
                </div>
                </div>
            <div className='right'>
              <h4>
                About me.
              </h4>
              <br></br>
              <Footer>
              This is Shitsama John, A beginner in the field of  front-end Software engineering and an advanced skilled
              music producer with the aim of globalizing music digitally.
              </Footer>
              <br></br>
              <div classname="social"> <Link target='_blank' to='https://www.linkedin.com/in/shitsamajohn'>
              <FaLinkedin size={30} 
              onMouseOver={({target})=>target.style.color="gray"}
              onMouseOut={({target})=>target.style.color="white"}
              style={
                      {color:"#fff", marginRight:"2rem"}
                    } />
                    </Link>
                    <Link target='_blank' to='https://github.com/tropicalmonroe'>
                    <FaGithub size={30} 
                    onMouseOver={({target})=>target.style.color="gray"}
                    onMouseOut={({target})=>target.style.color="white"}
                    style={
                      {color:"#fff", marginRight:"2rem"}
                    } />
                    </Link>
                    <Link target='_blank' to='https://www.instagram.com/tropicalmonroe'>
                    <FaInstagram  size={30} 
                    onMouseOver={({target})=>target.style.color="gray"}
                    onMouseOut={({target})=>target.style.color="white"}
                    style={
                      {color:"#fff", marginRight:"2rem"}
                    } />
                    </Link>
                    <Link target='_blank' to='https://open.spotify.com/artist/74W4kN8GOt7Gg2fOhXyhTJ?si=Xn7yVwitQ_mOVzGtYHmbAw'>
                    <FaSpotify  size={30} 
                    onMouseOver={({target})=>target.style.color="gray"}
                    onMouseOut={({target})=>target.style.color="white"}
                    style={
                      {color:"#fff", marginRight:"2rem"}
                    } />
                    </Link>
              </div>
              </div>
      </div>
    </div>
  )
}
const textfade = keyframes `
from {
  opacity: 0;
  transform: translateY(20px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`
;
const Footer = styled.p`
animation-name: ${textfade};
animation-duration: 2500ms;
animation-delay: 2000ms;
animation-iteration-count: 2;
` 

export default footer